module.exports = __webpack_public_path__ + "img/0Q3A3452_L_Foamcore.69707567.jpg";